import React, { useRef, useState, useEffect } from 'react';
import Header from "../Components/header";
import fileDownload from 'js-file-download';
import BACK from '../../src/images/icon-back-b.svg';
import { SubmitHandler, useForm } from "react-hook-form";
import baseUrlApi from "../lib/baseUrlApi";
import { useNavigate, useParams } from "react-router-dom";
import Utility from "../Consts/Utility";
import {ApiRequest} from "../Consts/ApiRequest";
import {useCookies} from "react-cookie";
import SensorKindConsts from "../Consts/SensorKinds";


type Sensor = {
    gatewaySensorGroupRecno: number;
    sensorRecno: number;
    sensorId: string;
    sensorName: string;
    sensorKind: number;
    checked: boolean;
};

type Gateway = {
    gatewayRecno: number;
    gatewayId: string;
    siteGatewayGroupRecno: string;
    controlId: string;
    contactEnd: string;
    sitePass: {
        admin: string;
        user: string;
    };
    checked:boolean,
    sensors: Sensor[];
};

type Site = {
    siteRecno: number;
    siteId: string;
    siteName: string | null;
    gateways: Gateway[];
};

type ApiResponse = {
    result: number;
    sites: Site[];
};

type Param = {
    siteId?: string;
    siteRecno?: string;
    siteName?: string;
    gatewayCount?: string;
    controlID?: string;
};

const DownloadFile = (props: any) => {
    const navigate = useNavigate();
    const [sites, setsites] = useState<Site[]>();
    const [histrical_start_date, setHistrical_start_date] = useState<string>('');
    const [histrical_end_date, setHistrical_end_date] = useState<string>('');
    const [siteName, setSiteName] = useState<string>('');
    const [param, setParam] = useState<Param>({});
    const [gw_count, setGwCount] = useState<number>(0);
    const [selectedSensors, setSelectedSensors] = useState<number[]>([]);
    const { register, handleSubmit, formState: { errors } } = useForm<any>();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const params: Param = useParams<Param>();
    const siteId: string = params.siteId ?? "";
    const siteRecno: string = params.siteRecno ?? "";

    // チェックボックスの変更イベント
    const handleSensorCheckChange = (gatewaySensorGroupRecno: number, isChecked: boolean) => {
        let newSites = sites?.map((site)=>{
            let newSite:Site = site;
            newSite.gateways = site.gateways.map((gateway)=>{
                gateway.sensors = gateway.sensors.map((sensor)=>{
                    if(sensor.gatewaySensorGroupRecno == gatewaySensorGroupRecno){
                        sensor.checked = isChecked;
                    }
                    return sensor;
                });
                return gateway;
            });
            return  newSite;
        });
        setsites(newSites);
    };

    // Gatewayのチェックボックスの変更イベント
    const handleGatewayCheckChange = (gatewayArg: Gateway, isChecked: boolean) => {
        const sensorRecnosForThisGateway = gatewayArg.sensors.map(sensor => sensor.sensorRecno);
        let newSites = sites?.map((site)=>{
            let newSite:Site = site;
            newSite.gateways = site.gateways.map((gateway)=>{
                if(gateway.gatewayId !== gatewayArg.gatewayId){
                    return gateway;
                }
                gateway.checked = isChecked;
                gateway.sensors = gateway.sensors.map((sensor)=>{
                    sensor.checked = isChecked;
                    return sensor;
                });
                return gateway;
            });
            return  newSite;
        });
        setsites(newSites);
    };


    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    // すべてチェックボックスの変更イベント
    const handleAllCheckChange = (isChecked: boolean) => {
        let newSites = sites?.map((site)=>{
            let newSite:Site = site;
            newSite.gateways = site.gateways.map((gateway) => {
                gateway.checked = isChecked;
                gateway.sensors = gateway.sensors.map((sensor) => {
                    sensor.checked = isChecked;
                    return sensor;
                });
                return gateway;
            });
            return  newSite;
        });
        setsites(newSites);
    };

    // 日時のフォーマット変換
    function ReformatDate(inputDateString: string) {
        const parts = inputDateString.replace(/-/g, '/').replace('T', ' ');
        return parts;
    }
    useEffect(() => {
        if(cookies.authority == 4){
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }

        const token = cookies.access_token || "";
        let params = {
            siteId: siteId ?? "",
            siteRecno: siteRecno ?? ""
        }
        ApiRequest.getSiteSetting(params, token,
            (response:any) => {
            setSiteName(response.data.siteName);
        }, (error: any) => {
            errorCallback(error);
        });

        let siteParams = {
            prcKind: 1,
            siteId: siteId,
            siteRecno: siteRecno,
            // contactEnd: "2030/12/31",
            sitePass: {
                admin: "",
                user: ""
            },
            deviceInfo: {
                gatewayID: "",
                sensorID: ""
            },
        };

        ApiRequest.getSiteEq(siteParams, token, (response: any) => {
            const data: ApiResponse = response.data;
            let gwCount:number = 0;
            data.sites = data.sites.map((site, index) =>{
                site.gateways = site.gateways.filter(gateway=>gateway.gatewayRecno);
                gwCount += site.gateways.length;
                return site;
            });
            setsites(data.sites);
            setGwCount(gwCount);
        }, (error:any) => {
            errorCallback(error);
        });
    }, []);

    // 全てをダウンロード
    const downloadAllZipFile = async () => {
        try {
            let params = {
                prcKind: 0,
                siteRecno: siteRecno,
                siteId: siteId,
            };
            const token = cookies.access_token || "";
            ApiRequest.postDataDownloadBlob(
                params, token, (response: any) => {
                    if(response.data.result == -1){
                        alert(response.data.message.join("\n"));
                    }else{
                        fileDownload(response.data, 'sooki-file.zip');
                    }
                }, (error: any) => {
                    errorCallback(error);
                }
            );
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // 個別ダウンロード
    const downloadSelectedZipFile = async () => {
        const ReformattedDateStart = ReformatDate(histrical_start_date == "" ? "1900-01-01 00:00" : histrical_start_date);
        const ReformattedDateEnd = ReformatDate(histrical_end_date == "" ? "2100-01-01 00:00" : histrical_end_date);
        const selectedGateways = sites?.flatMap(site =>
            site.gateways.map(gateway => ({
                siteGatewayGroupRecno: gateway.siteGatewayGroupRecno,
                gatewayRecno: gateway.gatewayRecno,
                gatewayId: gateway.gatewayId,
                sensors: gateway.sensors
                    .filter(sensor => sensor.checked)
            }))
        ).filter(gateway => gateway.sensors.length > 0) || [];


        var params = {
            prcKind: 1,
            siteRecno: siteRecno,
            siteId: siteId,
            targetDatetime: {
                start: ReformattedDateStart,
                end: ReformattedDateEnd,
            },
            gateways: selectedGateways.map(function (gateway){
                let checks = gateway.sensors.map(function(sensor){
                    return {
                        sensorKind: sensor.sensorKind,
                        gatewaySensorRecno: sensor.gatewaySensorGroupRecno
                    }
                });
                return {
                    siteGatewayRecno: gateway.siteGatewayGroupRecno,
                    checks: checks
                };
            }),
        };

        try {
            const token = cookies.access_token || "";
            ApiRequest.postDataDownloadBlob(params,token, (response: any) => {
                const isJsonBlob = (data: any) => {
                    return data instanceof Blob && data.type === "application/json";
                }

                const processResponse = async (response:any) => {
                    let responseData = response?.data || {};
                    if (isJsonBlob(response?.data)) {
                        // awaitを使用してPromiseを解決
                        responseData = await (response?.data)?.text();
                    }

                    const responseJson = (typeof responseData === "string") ? JSON.parse(responseData) : responseData;
                    if(responseJson.result == -1){
                        alert(responseJson.messsages.join("\n"));
                    }else{
                        fileDownload(response.data, 'selected-sensors-file.zip');
                    }
                }
                processResponse(response);

            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    const onSubmitAll: SubmitHandler<Site> = async (data) => {
        downloadAllZipFile();
    };
    const onSubmitSelected: SubmitHandler<Site> = async (data) => {
        downloadSelectedZipFile();
    };

    return (
        <>
            <div className="wrapper">
                <Header
                    showMenu={1}
                    siteId={siteId}
                    siteRecno={siteRecno}
                    siteName={siteName}
                />
                <section className="page-head" id="page-head">
                    <div className="page-head-block">
                        <div className="page-name">
                            <a onClick={() => navigate(-1)}>
                                <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" />
                            </a>
                            <div className="page-name-label">データダウンロード</div>
                        </div>
                        <div className="page-option">
                            <form onSubmit={handleSubmit(onSubmitAll)}>
                                <button className="btn btn-blue"><i className="icon-download-w"></i>一括ダウンロード</button>
                            </form>
                        </div>
                    </div>
                    <div className="page-head-block">
                        <div className="page-info-box">
                            <div className="page-info-item">
                                <span className="page-info-label">現場ID</span>
                                {siteId}
                            </div>
                            <div className="page-info-item">
                                <span className="page-info-label">Gateway登録数</span>
                                {gw_count}
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-body scroll-block" style={{height: "80vh"}}>
                    <div className="sort-box">
                        <div className="sort-box-elm">
                            <div className="search-box-elm-input check-wrap">
                                <input
                                    type="checkbox"
                                    id="check01"
                                    name="check01"
                                    onChange={(e) => handleAllCheckChange(e.target.checked)}
                                />
                                <label htmlFor="check01">すべてチェック</label>
                            </div>
                        </div>
                        <div className="sort-box-group">
                            <span>対象期間</span>
                            <input
                                type="datetime-local"
                                value={histrical_start_date}
                                id=""
                                name=""
                                className="col-200"
                                min="0000-01-01T00:00"
                                max="9999-12-31T00:00"
                                onChange={(e) => setHistrical_start_date(e.target.value)}
                            />
                            <span>〜</span>
                            <input
                                type="datetime-local"
                                value={histrical_end_date}
                                id=""
                                name=""
                                className="col-200"
                                min="0000-01-01T00:00"
                                max="9999-12-31T00:00"
                                onChange={(e) => setHistrical_end_date(e.target.value)}
                            />
                            <div className="sort-box-btn">
                                <span>選択したデータを</span>
                                <form onSubmit={handleSubmit(onSubmitSelected)}>
                                    <button className="btn btn-blue"><i className="icon-download-w"></i>ダウンロード</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="list-box">
                        <ul className="st-list">
                            {sites?.map((site) => (
                                <ul className="parent-list" key={site.siteRecno}>
                                    {site.gateways.map((gateway) => (
                                        <li key={gateway.siteGatewayGroupRecno} className="parent">
                                            <div className="parent-body">
                                                <input
                                                    type="checkbox"
                                                    id={`gateway-${gateway.siteGatewayGroupRecno}`}
                                                    checked={gateway.checked ?? false}
                                                    name={`gateway-${gateway.siteGatewayGroupRecno}`}
                                                    onChange={(e) => handleGatewayCheckChange(gateway, e.target.checked)}
                                                />
                                                <div className="elm-label">Gateway管理番号</div>
                                                <div className="elm-body">{gateway.gatewayId}</div>
                                            </div>
                                            <ul className="children">
                                                {gateway.sensors?.map((sensor) => (
                                                    <li key={sensor.gatewaySensorGroupRecno} className="child">
                                                        <input
                                                            type="checkbox"
                                                            id={`sensor-${sensor.gatewaySensorGroupRecno}`}
                                                            name={`sensor-${sensor.gatewaySensorGroupRecno}`}
                                                            checked={sensor.checked ?? false}
                                                            onChange={(e) => handleSensorCheckChange(sensor.gatewaySensorGroupRecno, e.target.checked)}
                                                        />
                                                        <div className="sensor-label">{SensorKindConsts.getKind(sensor.sensorKind)}</div>
                                                        <div className="elm-label">管理番号</div>
                                                        <div className="elm-data">{sensor.sensorId}</div>
                                                        <div className="elm-label">センサ名</div>
                                                        <div className="elm-data">{sensor.sensorName}</div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    ))}
                                </ul>
                            ))}
                        </ul>
                    </div>
                </section>
            </div>
        </>
    )
}
export default DownloadFile

